import { z } from 'zod';

const CustomerSchema = z.object({
    id: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    created_by: z.string(),
    name: z.string(),
    address: z.string(),
    phone_number: z.string(),
    email: z.string().email(),
    customer_type: z.enum(['wholesale']),
    status: z.enum(['active', 'inactive']).default('active'),
});
export type Customer = z.infer<typeof CustomerSchema>;

const WholesaleRequestItemSchema = z.object({
    id: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    request_id: z.string(),
    product_variation_id: z.string(),
    available_quantity: z.number().optional(),
    quantity: z.number(),
    // unit_price: z.number(),
    wholesale_price: z.coerce.number(),
    purchase_price: z.number(),
    retail_price: z.number(),
    product_name: z.string().optional(),
    brand: z.string().optional(),
    generic: z.string().optional(),
    strength: z.string().optional(),
    type: z.string().optional(),
});
export type WholesaleRquestItem = z.infer<typeof WholesaleRequestItemSchema>;

export const WholesaleAdminRequestSchema = z.object({
    id: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    customer_id: z.string(),
    customer: CustomerSchema,
    notes: z.string().optional(),
    total_items: z.number().optional(),
    total_price: z.number().optional(),
    items: z.array(WholesaleRequestItemSchema).optional(),
});
export type WholesaleAdminRequest = z.infer<typeof WholesaleAdminRequestSchema>;

export const WholesaleAdminRequestResponseSchema = z.object({
    data: WholesaleAdminRequestSchema,
});
export type WholesaleAdminRequestResponse = z.infer<
    typeof WholesaleAdminRequestResponseSchema
>;
